<template>
    <v-container fluid>
        <v-card v-if="payresponse">
            <v-card-text>
                <v-card-title>
                    {{ message }}<div v-if="messageext.toString().length > 0">{{ messageext }}</div>
                </v-card-title>
                <!-- <v-card-subtitle v-if="amount.toString() !== '0'">
                    Amount: &#8369;{{ amount }}
                </v-card-subtitle> -->

                <v-card-subtitle>
                    <v-btn
                        text
                        @click="ReturnToDashboard"
                    >
                        Go to Dashboard
                    </v-btn>
                </v-card-subtitle>
            </v-card-text>

            <v-card-text>
                <v-card-title
                    v-if="eormessage.toString().length > 0"
                >
                    {{ eormessage }}
                </v-card-title>

                <v-progress-linear
                    v-if="eorloaded == false"
                    indeterminate
                    color="red darken-2"
                    height="20"
                    rounded
                    class="mb-5"
                ></v-progress-linear>

                <iframe
                    ref="chartiframe"
                    id="datawrapper-chart-8dfPN" 
                    :src="iframe.src"
                    scrolling="yes"
                    frameborder="0"
                    allowtransparency="true"
                    style="width: 0; min-width: 100% !important;"
                    :height="iframe.height"
                    @load="EORonLoad"
                    class="mt-2"
                >
                    <v-overlay
                        :absolute="true"
                        :value="true"
                    ></v-overlay>
                </iframe>
            </v-card-text>
        </v-card>

        <v-progress-linear
            indeterminate
            color="yellow darken-2"
            height="15"
            rounded
            v-else
        ></v-progress-linear>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import numeral from "numeral"
import { State, interpret } from "xstate"
import { toggleMachine } from "../states/toggle"

export default {
    name: 'paymentstatus',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Payment Status',
    },
    data() {
        return {
            overlay: false,
            citizen: {},
            paymentid: '',
            requestid: '',
            amount: 0,
            message: '',
            messageext: '',
            payresponse: false,
            paymentstatuses: ['000.100.110', '000.100.112'],
            toggleService: interpret(toggleMachine),
            current: toggleMachine.initialState,
            context: toggleMachine.context,
            iframe: {
                src: ``,
                height: 400,
                width: '100%',
            },
            eorloaded: false,
            eormessage: '',
            redirecting: false,
            cb: null,
        }
    },
    methods: {
        ReturnToDashboard() {
            this.$router.push({
                name: 'dashboard'
            }).catch(() => {})
        },
        paymentrequest() {
            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/op_payment_request`,
                data: {
                    id: this.requestid.toString(),
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const requestdata = this.$jwt.decode(response.data.request, this.jwtsecret)

                        this.toggleService.send({
                            type: 'PAYMENTREQUEST',
                            paymentrequest: requestdata.request
                        })

                        this.paymentstatus()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: response.data.message.toString()
                        })

                        setTimeout(() => {
                            this.redirect()
                        }, 2000)
                    }
                })
                .catch(() => {
                    this.overlay = false

                    this.$emit('snackbar', {
                        variant: 'red darken-2',
                        message: 'Something went wrong, redirecting...'
                    })

                    setTimeout(() => {
                        this.redirect()
                    }, 2000)
                })
        },
        resultcodeschecking(resultcode) {
            let res = 0

            if(resultcode.match(/^(000\.000\.|000\.100\.1|000\.[36])/)) {
                res = 1
            }

            if(resultcode.match(/^(000\.400\.0[^3]|000\.400\.100)/) || resultcode.match(/^(000\.400\.0[^3]|000\.400\.[0-1]{2}0)/)){
                res = 1
            }

            if(resultcode.match(/^(000\.200)/)){
                res = 2
            }

            if(resultcode.match(/^(800\.400\.5|100\.400\.500)/)){
                res = 0
            }

            return res
        },
        paymentstatus() {
            if(this.paymentid){ // we got a payment id it must be nationlink
                axios({
                    method: `post`,
                    url: `${this.domain}/altpaynetstatus`,
                    data: {
                        id: this.paymentid.toString(),
                    }
                })
                    .then(response => {
                        // if(this.paymentstatuses.indexOf(response.data.result.code.toString()) > -1){
                        const rcode = this.resultcodeschecking(response.data.result.code.toString())

                        this.payresponse = true

                        if([1].indexOf(rcode) > -1){
                            this.amount = numeral(parseFloat(response.data.amount)).format('0,0.00')
                            // this.message = response.data.result.description

                            // this.$emit('snackbar', {
                            //     variant: 'green darken-2',
                            //     message: 'Payment Gateway received your payment, redirecting..'
                            // })
                        }
                        // else{
                        //     // this.$emit('snackbar', {
                        //     //     variant: 'red darken-2',
                        //     //     message: response.data.result.description.toString()
                        //     // })

                        //     // this.message = response.data.result.description
                        // }

                        // console.log(response.data)

                        this.message = response.data.result.description
                        this.messageext = response.data.resultDetails ? response.data.resultDetails.ExtendedDescription : ''

                        if(parseInt(rcode) != 2) {
                            this.updaterequest(response.data, rcode)
                        } else{
                            this.message = 'Transaction is still processing... Do not close this tab/window.'
                            this.messageext = ''

                            setTimeout(() => {
                                this.paymentstatus()
                            }, 5000)
                        }
                    })
            } else if(this.cb){
                // console.log(this.$route.query.transaction_id)
                axios({
                    method: 'post',
                    url: `${this.domain}/altpaynetstatus_v2`,
                    data: {
                        requestid: this.requestid.toString(),
                        cb: this.cb,
                        transactionid: this.$route.query.transaction_id || '',
                    }
                })
                    .then(response => {
                        // console.log(response.data)
                        this.payresponse = true

                        if(response.data.response){
                            this.updaterequest(response.data.nationlinkresp, response.data.rcode)
                        } else{
                            this.message = response.data.result.description
                        }
                    })

                // console.log(this.cb)
            } else{
                // fortunepay
                // check transaction
                // console.log(this.$route.query)
                axios({
                    method: 'post',
                    url: `${this.domain}/fortunepay_check_transaction`,
                    data: {
                        requestid: this.requestid.toString(),
                    }
                })
                    .then(response => {
                        if(response.data.response){
                            const rcode2 = response.data.fp_resp.txn_status.toString().toLowerCase() == 'success' ? 1 : 0

                            this.payresponse = true

                            this.updaterequest(response.data.fp_resp, rcode2)
                        }
                    })
            }
        },
        updaterequest(altpaynetstatus, rcode) {
            axios({
                method: 'post',
                url: `${this.domain}/op_payment_request_update`,
                data: {
                    requestid: this.requestid.toString(),
                    altpaynetstatus: JSON.stringify(altpaynetstatus),
                    rcode,
                }
            })
                .then(response => {
                    // this.overlay = true
                    // if payment gateway received payment, print
                    if(response.data.ornum && response.data.ornum.toString().length > 0 && [1].indexOf(rcode) > -1){
                        let _link = ''

                        switch(response.data.division) {
                            case 'RPTCLEARANCE': case 'CHISS':
                                _link = `${this.treasuryapi}/MiscEOR.php?data=${response.data.ornum.toString()}`

                                this.iframe.height = 860
                                break;
                            case 'RPT':
                                // _link = `http://35.220.187.169/Treasury/EORPrint.php?data={"collection":["${response.data.ornum.toString()}"]}`
                                _link = `${this.treasuryapi}/EORPrint.php?data={"collection":["${response.data.ornum.toString()}"]}`

                                this.iframe.height = 560
                                break;
                            case 'BPLO':
                                // console.log(112343425435)

                                // _link = `http://35.220.187.169/Treasury/EORBPLO.php?data=${response.data.ornum.toString()}`

                                _link = `${this.treasuryapi}/EORBPLO.php?data=${response.data.ornum.toString()}`
                                this.iframe.height = 860
                                break;
                        }

                        // message
                        switch(response.data.division) {
                            case 'RPTCLEARANCE':
                                this.eormessage = 'Please claim your Tax Clearance Document by showing this receipt at the Treasury Department of the City Hall'
                                break;
                        }

                        // if(_link.toString().length > 0){
                        //     setTimeout(() => {
                        //         const win = window.open(_link, '_blank')
                        //         win.focus()
                        //     }, 500)
                        // }

                        console.log(response.data)
                        console.log(this.iframe)

                        if(_link.toString().length > 0){
                            this.iframe.src = _link
                        }
                    } else{
                        setTimeout(() => {
                            this.redirect()

                            this.redirecting = true
                        }, 30000)
                    }
                })
                .catch(() => {
                    // this.overlay = true

                    setTimeout(() => {
                        this.redirect()

                        this.redirecting = true
                    }, 30000)
                })
        },
        redirect() {
            switch(this.context.paymentrequest.division.toString()){
                case 'BPLO':
                    this.$router.push({
                        name: 'bplopayment'
                    }).catch(() => {})
                    break;
                case 'RPTCLEARANCE':
                    this.$router.push({
                        name: 'rptclearance'
                    }).catch(() => {})
                    break;
                case 'RPT':
                    this.$router.push({
                        name: 'rptpayment'
                    }).catch(() => {})
                    break;
                case 'CHISS':
                    this.$router.push({
                        name: 'listofalltransactions'
                    }).catch(() => {})
                    break;
                default:
                    this.$router.push({
                        name: 'dashboard'
                    }).catch(() => {})
                    break;
            }
        },
        EORonLoad() {
            this.eorloaded = true
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.paymentid = this.$route.query.id || null
        this.requestid = this.$route.params.requestid.toString()
        this.cb = this.$route.query.cb || null

        // this.paymentrequest()
        this.paymentstatus()
    },
    created() {
        const stateDefinition = JSON.parse(localStorage.getItem('app-xstate')) || toggleMachine.initialState
        const previousState = State.create(stateDefinition)
        const resolvedState = toggleMachine.resolveState(previousState)

        this.toggleService
            .onTransition(state => {
                this.current = state
                this.context = state.context

                localStorage.setItem('app-xstate', JSON.stringify(state))
            })
            .start(resolvedState)
    }
}
</script>